const JWT_PATTERN = /^eyJ[\w-]*\.[\w-]*\.[\w-]*$/

// Older builds wrote localStorage[<jwt>] = <jwt> on every token refresh until storage hit its quota.
export const purgeLegacyTokenKeys = (): number => {
  const stale = Object.keys(localStorage).filter((k) => JWT_PATTERN.test(k))
  for (const k of stale) localStorage.removeItem(k)
  return stale.length
}
